import { render, staticRenderFns } from "./live-tv.vue?vue&type=template&id=eab8d140&"
import script from "./live-tv.vue?vue&type=script&lang=js&"
export * from "./live-tv.vue?vue&type=script&lang=js&"
import style0 from "./live-tv.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports